import React from "react"
import { useParams } from "react-router";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useMyProfileQuery } from "../../../services/profileService/profile-api";
import { VarianceWorklistRequest } from "../../../services/varianceService/commands";
import { useFindWorklistQuery } from "../../../services/varianceService/variance-api";
import { PermissionChecker } from "../../../services/varianceService/util/PermissionChecker";

type OwnProps = {
    title: string;
    queryParam: string;
}

function AdminVarianceDashboardCard(props: OwnProps) {
    const { center } = useParams();
    const profile = useMyProfileQuery();
    
    const isAdmin = (): boolean => {
        return PermissionChecker.isVarianceAdmin(profile.data, center) || PermissionChecker.isVarianceQualityTeam(profile.data, center);
    };
    
    const shouldFetch = !!profile.data?.upn && isAdmin();
    const request = shouldFetch && profile.data
        ? new VarianceWorklistRequest(center!, props.queryParam, true, profile.data.upn)
        : undefined;
        
    const { data } = useFindWorklistQuery(
        request!,
        { skip: !shouldFetch }
    );

    if (!isAdmin()) {
        return null;
    }

    return (
        <Card className='card' sx={{width:'200px', borderRadius:'5pt'}}>
            <CardHeader 
                className='card-header' 
                sx={{textAlign:'center'}} 
                title={<Typography color='#62BCBD' fontWeight={700} variant='body2'>{props.title}</Typography>}
            />
            <CardContent>
                <h2 className="center-align">
                    <Link 
                        style={{color: '#d32f2f'}}
                        to={"/VarianceWorklist/"+ center + '/' + props.queryParam}>{data?.length ?? 0}
                    </Link>
                </h2>
            </CardContent>
        </Card>
    );
}

export { AdminVarianceDashboardCard }
